/**
 * User role definitions for the admin portal
 * Centralized role constants to avoid duplication across components
 */

export const COMMON_ROLES = [
  'Admin',
  'LoungeManager',
  'Staff',
  'OfficeHead',
] as string[];

export const CUSTOMER_CARE_ROLES = ['CustomerCare'] as string[];

export const OFFICE_HEAD_ROLES = ['OfficeHead', 'Admin'] as string[];

export const ADMIN_ROLES = ['Admin'] as string[];

// Type definitions for better TypeScript support
export type CommonRole = (typeof COMMON_ROLES)[number];
export type AdminRole = (typeof ADMIN_ROLES)[number];
export type OfficeHeadRole = (typeof OFFICE_HEAD_ROLES)[number];
export type UserRole = CommonRole | AdminRole | OfficeHeadRole;
